/**
 * Created by mac on 7/26/18
 */

const RiddlesLivesFeastWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission, options) {
        this.mission = mission;

        options = options || {};
        this.options = options;
        const offer = this.offer = cleverapps.offerManager.findOffer({ mission: mission.type });

        this._super({
            name: "RiddlesLivesFeastWindow",
            content: new RiddlesLivesFeastView(this),
            noBackground: true,
            closeButton: false,
            styles: cleverapps.styles.RiddlesLivesFeastWindow.window,
            notCloseByTouchInShadow: true,
            offerWindowButton: offer ? {
                text: Messages.get(`FeastMissionWindow.${mission.getName()}.offer`),
                offerType: offer.type,
                onClicked: this.onOfferClicked.bind(this),
                bundle: "livesfeast_window",
                badgeText: Messages.get(`FeastMissionWindow.${mission.getName()}.offerBadge`)
            } : undefined,
            openSound: bundles.livesfeast_window.urls.feast_window_effect
        });

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        this.mission.runningCompetition.updateShownPlace();
        this.mission.updateMissionIcon();

        this._super();
    },

    onOfferClicked: function () {
        ComponentMap.get(this, WindowComponent).closeWindow();
        cleverapps.offerManager.showOfferWindow(this.offer);
    },

    getPerson: function () {
        return {
            role: "warlock",
            emotion: "happy"
        };
    },

    listBundles: function () {
        return ["livesfeast_window"];
    }
});

cleverapps.styles.RiddlesLivesFeastWindow = {
    verticalWindow: {
        windowShowUpAnimation: undefined,
        Background: {
            padding: {
                x: -10
            }
        }
    },

    window: {
        windowShowUpAnimation: undefined
    }
};
